export const RESET_STATE = '@trybeapp/ui/InventoryScreen/RESET_STATE'
